import React, { Fragment, useState, useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'

import { AppLoader } from '@portal/kit/pkg/components'
import { isRanAvailable } from '@portal/kit/pkg/services'

import { SubscriptionContext } from 'components/providers/subscription'

import { PaymentContext } from 'components/providers/payment'

import CatalogListView from '../catalog-list'

const OfferListContainer = () => {
  const { subscriptions } = useContext(SubscriptionContext)
  const [fetching, setFetching] = useState(null)
  const [disabledMessagesKeys, setDisabledMessagesKeys] = useState({})
  const { catalogs } = useContext(PaymentContext)

  const checkRan = async () => {
    try {
      const response = await isRanAvailable()
      setDisabledMessagesKeys(prev => ({...prev, ran: response.data.available ? null : 'offers.ran.unavailable'}))
    } catch {
      setDisabledMessagesKeys(prev => ({...prev, ran:'offers.ran.unavailable'}))
    } finally {
      setFetching(false)
    }
  }

  useEffect(() => {
    if (subscriptions && subscriptions.length > 0) setDisabledMessagesKeys(prev => ({ ...prev, internet_subscriptions :'offers.unavailable' }))
    checkRan()
  }, [subscriptions])

  if (!catalogs || fetching) return <AppLoader />

  return (
    <Fragment>
      <CatalogListView catalogs={catalogs} disabledMessagesKeys={disabledMessagesKeys} />
    </Fragment>
  )
}

export default withRouter(OfferListContainer)
